<template>
    <div class="contant" v-title="pageTitle">
        <div class="cont">
            <!-- 订单编号 -->
            <div class="flx ai" @click.stop="copy_">
                <div class="sz wd1 ta">订单编号: </div>
                <div class="sz_ wd2 ta">{{ orderdata.order.orderSn}}</div>
            </div>
            <div class="line"></div>
            <!-- 订单状态 -->
            <div class="flx">
                <div class="sz wd1 ta">订单状态: </div>
                <div
                    :class="orderdata.order.orderStatus == 203 ? 'sz_ s0' : ''||orderdata.order.orderStatus == 202 ? 'sz_ s3' : '' || orderdata.order.orderStatus == 201 ? 'sz_ s2' : '' || (orderdata.order.orderStatus == 201 || orderdata.order.orderStatus == 301 || orderdata.order.orderStatus == 401 || orderdata.order.orderStatus == 402) ? 'sz_ s1' : '' || (orderdata.order.orderStatus == 101 || orderdata.order.orderStatus == 102 || orderdata.order.orderStatus == 103 || orderdata.order.orderStatus == 204) ? 'sz_ s4' : ''">
                    {{ statusReturn(orderdata.order.orderStatus) }}</div>
            </div>
            <div class="line"></div>
            <!-- 订单用户 -->
            <div class="flx">
                <div class="sz wd1 ta">订单用户: </div>
                <div class="sz_ ta">{{ orderdata.order.consignee }}</div>
            </div>
            <div class="line"></div>
            <!-- 用户留言 -->
            <div class="flx">
                <div class="sz wd1 ta">用户留言: </div>
                <div class="sz_ wd2 ta">{{ orderdata.order.message }}</div>
            </div>
            <div class="line"></div>
            <!-- 收货信息 -->
            <div class="flx" @click.stop="copy">
                <div class="sz  wd1 ta" style="width: 40%;">收货信息: </div>
                <div class="sz_ tl ta">(收货人){{ orderdata.order.consignee }} (手机号){{ orderdata.order.mobile }} (地址){{ orderdata.order.address }}
                </div>
            </div>
            <div class="line"></div>

            <!-- 产品信息 -->
            <div>
                <div class="sz tl">产品信息: </div>
                <div v-for="(items, index) in orderdata.orderGoods" :key="index">
                    <div class="goods">
                        <div class="flx_ szimg">
                            <img :src="items.picUrl" class="imgs" @click.stop="prmImg(index)" />
                            <div class="im">
                                <div class="mg">{{ items.goodsName }}</div>
                                <div class="mg">{{ items.goodsSn }}</div>
                                <div class="mg">{{ items.specifications.toString() }}</div>
                                <div class="szimg">¥ {{ items.price }}</div>
                            </div>
                            <div>X {{ items.number }}</div>
                        </div>
                    </div>
                    <div class="line"></div>
                </div>

            </div>
            <!-- 费用信息 -->
            <div class="flx">
                <div class="sz wd tl wd1" style="width: 40%;">费用信息: </div>
                <div class="sz_ tl">(实际费用) {{ orderdata.order.actualPrice }}元 = (商品总价) {{ orderdata.order.goodsPrice }}元 + (快递费用){{
                    orderdata.order.freightPrice }}元 -(优惠减免) {{ orderdata.order.couponPrice }}元 -(积分减免) {{ orderdata.order.integralPrice }}元
                </div>
            </div>
            <div class="line"></div>
              <!-- 佣金信息 -->
              <div class="flx" v-show="orderdata.order.totalCommission >0">
                <div class="sz wd1 ta">佣金信息: </div>
                <div class="sz_ ta redco">（扣除佣金） {{ orderdata.order.totalCommission }}元</div>
            </div>

            <div class="line" v-show="orderdata.order.totalCommission >0"></div>
            <!-- 支付信息 -->
            <div class="flx">
                <div class="sz wd tl wd1">支付信息: </div>
                <div class="sz_ tl wd2">（支付渠道）微信支付（支付时间） {{ orderdata.order.payTime }}</div>
            </div>
            <div class="line"></div>
            <!-- 快递信息 -->
            <div class="flx">
                <div class="sz wd tl wd1">快递信息: </div>
                <div class="sz_ tl wd2">
                    (快递公司) {{ orderdata.order.shipChannel }}(快递单号){{ orderdata.order.shipSn }}(发货时间){{ orderdata.order.shipTime }}
                </div>
            </div>
            <div class="line"></div>
            <!-- 退款信息 -->
            <div class="flx">
                <div class="sz wd tl wd1">退款信息: </div>
                <div class="sz_ tl wd2">
                    (退款金额) {{ orderdata.order.refundAmount }}元 (退款类型){{ orderdata.order.refundType }}(退款备注){{ orderdata.order.refundContent }}
                    (退款时间){{ orderdata.order.refundTime }}
                </div>
            </div>
            <div class="line"></div>
            <!-- 收货信息 -->
            <div class="flx">
                <div class="sz wd tl wd1">收货信息: </div>
                <div class="sz_ tl wd2">
                    (确认收货时间) {{ orderdata.order.confirmTime }}
                </div>
            </div>
            <div class="line"></div>
        </div>
        <div style="position: fixed;bottom: 10px;display: flex;justify-content: center;width: 100%;"
            v-if="orderdata.order.orderStatus == 201">
            <van-button style="width: 200px;" round type="info" @click.stop="show = true">发 货</van-button>
        </div>
        <div style="position: fixed;bottom: 10px;display: flex;justify-content: center;width: 100%;"
            v-if="orderdata.order.orderStatus == 202">
            <van-button style="width: 200px;" round type="info" @click.stop="refund">退 款</van-button>
        </div>
        <van-dialog v-model="show" title="发货" show-cancel-button @confirm="apply">
            <div style="padding-top:20px;padding-bottom:20px">
                <van-field v-model="company" label="快递公司" placeholder="请选择" disabled @click.stop="showp = true" />
                <van-field v-model="tracking_number" label="快递单号" placeholder="" right-icon="scan" @click-right-icon="Toscan" />
            </div>
        </van-dialog>
        <van-popup v-model="showp" position="bottom" :style="{ height: '40%' }">
            <van-picker title="快递选择" show-toolbar :columns="sel" @confirm="onConfirm" @cancel="onCancel"
                @change="onChange" />
        </van-popup>

    </div>
</template>

<script>
import { ImagePreview } from 'vant'
import request from '../api/request'
export default {
    data() {
        return {
            pageTitle: '订单详情', orderdata: {order:{orderSn:''}}, show: false, tracking_number: '', company: '', sel: ['中通快递', '圆通速递', '韵达速递', '极兔快递', '邮政快递包裹', 'EMS', '德邦快递'],
            showp: false
        }
    },
    mounted() {
        // console.log(this.$route.query)
        // this.orderdata = JSON.parse(localStorage.getItem('details'))
        
        const parms={id:localStorage.getItem('details_id')}
        request.getcommerlist(parms,'/admin/order/detail','get',localStorage.getItem('token_yr'),res=>{
            console.log(res)
            this.orderdata =res.data
        })
        if(localStorage.getItem('companyIndex')!=undefined) this.company=this.sel[Number(localStorage.getItem('companyIndex'))]
    },
    methods: {
        prmImg(e){
            ImagePreview({
              images: [this.orderdata.orderGoods[e].picUrl],
             closeable: true,
             startPosition:0
          });
        },
        copy() {
            this.$copyText('(收货人)' + this.orderdata.order.consignee + '(手机号)' + this.orderdata.order.mobile + '(地址)' + this.orderdata.order.address).then(() => {
                this.$toast("成功复制！")
            }).catch(() => {
                this.$toast("复制失败")
            })
        },
        copy_(){
            this.$copyText('订单编号:' + this.orderdata.order.orderSn).then(() => {
                this.$toast("成功复制！")
            }).catch(() => {
                this.$toast("复制失败")
            })
        },
        onCancel() { this.showp = false },
        onConfirm(value, index) {
            this.showp = false
            this.company = value
            console.log(`当前值：${value}, 当前索引：${index}`)
            localStorage.setItem('companyIndex',index)
        },
        apply(){
            if(this.tracking_number==''||this.company=='') return
            const parms={
                orderId:this.orderdata.order.id,
                shipSn:this.tracking_number,
                shipChannel:this.company
            }
            request.getcommerlist(parms,'/admin/order/ship','post',localStorage.getItem('token_yr'),res=>{
                console.log(res)
                if(res.errno==0){
                   
                    this.$router.back()
                }
                this.$toast(res.errmsg)
            })
        },
        refund(){
            this.$dialog.alert({
                 title:'退款',
                 message: '确定退款？',
                 showCancelButton:true,
               }).then(() => {
                const parms={
                    orderId: this.orderdata.order.id,
                    refundMoney:this.orderdata.order.actualPrice
                }
                request.getcommerlist(parms,'/admin/order/refund','post',localStorage.getItem('token_yr'),res=>{
                console.log(res)
                if(res.errno==0){
                    this.$router.back()
                }
                this.$toast(res.errmsg)
            })
             });
        },
        onChange() { },
        statusReturn(e) {
            switch (e) {
                case 101:
                    return '待付款'
                    break;
                case 102:
                    return '用户取消'
                    break;
                case 103:
                    return '系统取消'
                    break;
                case 201:
                    return '已付款'
                    break;
                case 202:
                    return '申请退款'
                    break;
                case 203:
                    return '已退款'
                    break;
                case 301:
                    return '已发货'
                    break;
                case 401:
                    return '用户收货'
                    break;
                case 402:
                    return '系统收货'
                    break;
            }
        },
        // 调整扫一扫
        Toscan() {
            const parms = ''
            const pages = 'pages/scan/scan'
            request.postgetScheme(parms, pages, res => {
                console.log(res)
                if (res.errno == 0) {
                    location.href = res.data
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
/deep/ .van-field__control{
    color: #000;
}
.contant {
    background: #fff;
    height: 100%;
    width: 100%;
    overflow: scroll;
}

.cont {
    padding: 10px;
    padding-bottom: 100px;
}

.flx {
    display: flex;
    // align-items: center;
}
.ai{align-items: center;}
.flx_ {
    display: flex;
}

.sz {
    font-size: 15px;
    font-weight: 600;
}

.sz_ {
    font-size: 15px;
    margin-left: 10px;
}

.line {
    width: 100%;
    height: 1px;
    background: #f2f0f0;
    margin-top: 5px;
    margin-bottom: 5px;
}

.s0 {
    color: red;
    padding: 2px;
    background: #fab2b2;
    border: #f84e4e solid 1px;
    border-radius: 5px;
    font-size: 12px;
}

.s1 {
    color: rgb(68, 0, 255);
    padding: 2px;
    background: #a7acfb;
    border: #345cfb solid 1px;
    border-radius: 5px;
    font-size: 12px;
}

.s2 {
    color: rgb(18, 176, 55);
    padding: 2px;
    background: #c1fba7;
    border: #48fd3b solid 1px;
    border-radius: 5px;
    font-size: 12px;
}

.s3 {
    color: #fdc33b;
    padding: 2px;
    background: #f6f3c3;
    border: #fdc33b solid 1px;
    border-radius: 5px;
    font-size: 12px;
}
.s4 {
    color: #6d6d6c;
    padding: 2px;
    background: #d4d4d3;
    border: #999998 solid 1px;
    border-radius: 5px;
    font-size: 12px;
}
.wd {
    width: 140px;
}

.tl {
    text-align: left;
}

.imgs {
    width: 80px;
    height: auto;
    border-radius: 5px;
}

.goods {
    margin-top: 5px;
}

.szimg {
    font-size: 14px;
    text-align: left;
}

.im {
    margin-left: 10px;
    font-size: 12px;
    width: 230px;
}

.mg {
    padding-bottom: 5px;
    color: #807f7f;
}
.wd1{width:20%}
.wd2{width:80%}
.ta{text-align: left;}
.redco{color:red}
</style>